import React, { createContext, useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ApiService from './utils/api';
import './App.css';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminPanel from './pages/AdminPanel';
import ChangePassword from './pages/ChangePassword';
import SalarySlip from './pages/SalarySlip';

// Create Authentication Context
export const AuthContext = createContext();

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check authentication on app load
  useEffect(() => {
    const checkAuth = () => {
      const isAuthenticated = ApiService.isAuthenticated();
      setAuthenticated(isAuthenticated);
      
      if (isAuthenticated) {
        setUser(ApiService.getCurrentUser());
      }
      
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  // Route guard component for protected routes
  const ProtectedRoute = ({ children }) => {
    if (loading) {
      return <div className="loading-screen">Loading...</div>;
    }
    
    if (!authenticated) {
      return <Navigate to="/" />;
    }
    
    return children;
  };

  // Route guard for admin routes
  const AdminRoute = ({ children }) => {
    if (loading) {
      return <div className="loading-screen">Loading...</div>;
    }
    
    if (!authenticated) {
      return <Navigate to="/" />;
    }
    
    if (!user || !user.isAdmin) {
      return <Navigate to="/dashboard" />;
    }
    
    return children;
  };

  return (
    <AuthContext.Provider 
      value={{ 
        authenticated, 
        setAuthenticated, 
        user, 
        setUser, 
        login: async (username, password) => {
          try {
            const data = await ApiService.login(username, password);
            setAuthenticated(true);
            setUser(data.user);
            return data;
          } catch (error) {
            throw error;
          }
        },
        logout: () => {
          ApiService.logout();
          setAuthenticated(false);
          setUser(null);
        }
      }}
    >
      <div className="app">
        <Routes>
          <Route path="/" element={<Login />} />
          
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin" 
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            } 
          />
          
          <Route 
            path="/change-password" 
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/salary" 
            element={
              <ProtectedRoute>
                <SalarySlip />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </div>
    </AuthContext.Provider>
  );
}

export default App; 